import { atom, useAtom } from "jotai";

const defaultCoordinates = atom({});
export const useCoordinates = () => {
  const [coordinates, setCoordinates] = useAtom(defaultCoordinates);
  const adjustCoordinates = (lat, long) => {
    setCoordinates({
      latitude: lat,
      longitude: long,
    });
  };
  
  return {
    coordinates,
    adjustCoordinates,
  };
};
